import { createStore } from '@/src/hooks/store/createStore';
import type { SideNavigationProps } from '@amzn/awsui-components-react/polaris/side-navigation/interfaces';

export enum NavMenu {
  Mobile,
  CatalogFilter,
}

interface State {
  showSideNav: boolean;
  setShowSideNav: (showSideNav: boolean) => void;
  activeNavMenu?: NavMenu;
  setActiveNavMenu: (activeNav?: NavMenu) => void;
  userGuideToc: SideNavigationProps.Item[];
  setUserGuideToc: (toc?: SideNavigationProps.Item[]) => void;
}

export const useSideNav = createStore<State>(null, (set) => ({
  showSideNav: true,
  setShowSideNav: (showSideNav) => set({ showSideNav }),
  activeNavMenu: undefined,
  setActiveNavMenu: (activeNavMenu) => set({ activeNavMenu }),
  userGuideToc: [],
  setUserGuideToc: (toc) => set({ userGuideToc: toc ?? [] }),
}));
